(function() {
    'use strict';

    angular
        .module('ccsTrApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider', '$stickyStateProvider'];

    function stateConfig($stateProvider, $stickyStateProvider) {
        $stateProvider
            .state('sale', {
                parent: 'app',
                url: '/contract/sale',
                sticky: true,
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_TUI', 'ROLE_JPN'],
                    pageTitle: 'ccsTrApp.contract.sale.title',
                    title: 'Sales'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/contract/contracts.html',
                        controller: 'ContractController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    category: function () {
                        return {
                            type: "SALE"
                        }
                    },
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('contract');
                        $translatePartialLoader.addPart('contractType');
                        $translatePartialLoader.addPart('contractStatus');
                        $translatePartialLoader.addPart('contractCategory');
                        $translatePartialLoader.addPart('commodityType');
                        $translatePartialLoader.addPart('thirdPartyType');
                        $translatePartialLoader.addPart('priceModel');
                        $translatePartialLoader.addPart('priceType');
                        $translatePartialLoader.addPart('wtUnitType');
                        $translatePartialLoader.addPart('priceType');
                        $translatePartialLoader.addPart('wtUnitType');
                        $translatePartialLoader.addPart('onOff');
                        $translatePartialLoader.addPart('futuresMonth');
                        $translatePartialLoader.addPart('onCallIndex');
                        $translatePartialLoader.addPart('qtyUnitType');
                        $translatePartialLoader.addPart('deliveryType');
                        $translatePartialLoader.addPart('incoTerms');
                        $translatePartialLoader.addPart('paymentType');
                        $translatePartialLoader.addPart('global');
                        $translatePartialLoader.addPart('growth');
                        $translatePartialLoader.addPart('country');
                        return $translate.refresh();
                    }]
                }
            })
            .state('sale.all', {
                parent: 'app',
                url: '/contract/sale/all',
                sticky: true,
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_TUI', 'ROLE_JPN', 'ROLE_AGENT'],
                    pageTitle: 'ccsTrApp.contract.sale.title',
                    title: 'Sales'
                },
                views: {
                    'contract-sale-all@': {
                        templateUrl: 'app/entities/contract/contracts.html',
                        controller: 'ContractController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    category: function () {
                        return {
                            type: "SALE"
                        }
                    },
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('contract');
                        $translatePartialLoader.addPart('contractType');
                        $translatePartialLoader.addPart('contractStatus');
                        $translatePartialLoader.addPart('contractCategory');
                        $translatePartialLoader.addPart('commodityType');
                        $translatePartialLoader.addPart('thirdPartyType');
                        $translatePartialLoader.addPart('priceModel');
                        $translatePartialLoader.addPart('priceType');
                        $translatePartialLoader.addPart('wtUnitType');
                        $translatePartialLoader.addPart('priceType');
                        $translatePartialLoader.addPart('wtUnitType');
                        $translatePartialLoader.addPart('onOff');
                        $translatePartialLoader.addPart('futuresMonth');
                        $translatePartialLoader.addPart('onCallIndex');
                        $translatePartialLoader.addPart('qtyUnitType');
                        $translatePartialLoader.addPart('deliveryType');
                        $translatePartialLoader.addPart('incoTerms');
                        $translatePartialLoader.addPart('paymentType');
                        $translatePartialLoader.addPart('global');
                        $translatePartialLoader.addPart('growth');
                        $translatePartialLoader.addPart('country');
                        return $translate.refresh();
                    }]
                }
            })
            .state('sale.sale-detail', {
                parent: 'app',
                url: '/contract/sale/{id}/detail',
                sticky: false,
                views: {
                    'contract-sale-detail@': {
                        controller: 'ContractDetailController',
                        controllerAs: 'vm',
                        templateUrl: 'app/entities/contract/contract-detail.html'
                    }
                },
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_TUI', 'ROLE_JPN','ROLE_AGENT'],
                    pageTitle: 'ccsTrApp.contract.detail.sale',
                    title: 'Detail'
                },
                resolve: {
                    category: function () {
                        return {
                            type: "SALE"
                        };
                    },
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('contract');
                        $translatePartialLoader.addPart('contractType');
                        $translatePartialLoader.addPart('contractStatus');
                        $translatePartialLoader.addPart('contractCategory');
                        $translatePartialLoader.addPart('commodityType');
                        $translatePartialLoader.addPart('thirdPartyType');
                        $translatePartialLoader.addPart('priceModel');
                        $translatePartialLoader.addPart('priceType');
                        $translatePartialLoader.addPart('wtUnitType');
                        $translatePartialLoader.addPart('priceType');
                        $translatePartialLoader.addPart('wtUnitType');
                        $translatePartialLoader.addPart('onOff');
                        $translatePartialLoader.addPart('futuresMonth');
                        $translatePartialLoader.addPart('onCallIndex');
                        $translatePartialLoader.addPart('qtyUnitType');
                        $translatePartialLoader.addPart('deliveryType');
                        $translatePartialLoader.addPart('incoTerms');
                        $translatePartialLoader.addPart('paymentType');
                        $translatePartialLoader.addPart('growth');
                        $translatePartialLoader.addPart('country');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', '$state', 'ContractDTO', function ($stateParams, $state, ContractDTO) {
                        var paramId = $stateParams.id > 0 ? $stateParams.id : $state.params.id;
                        return ContractDTO.get({id : paramId}).$promise;
                    }],
                    previousState: ["$state", function ($state) {
                        return {
                            name: $state.current.name || 'sale',
                            params: $state.params,
                            url: $state.href($state.current.name, $state.params)
                        };
                    }]
                }
            })
            .state('sale.new', {
                parent: 'app',
                url: '/contract/sale/new?subCategory',
                sticky: true,
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_TUI'],
                    pageTitle: 'ccsTrApp.contract.sale.create',
                    title: 'New'
                },
                views: {
                    'contract-sale-new@': {
                        controller: 'ContractDialogController',
                        controllerAs: 'vm',
                        templateUrl: 'app/entities/contract/contract-dialog.html'
                    }
                },
                resolve: {
                    category: function () {
                        return {
                            type: "SALE"
                        }
                    },
                    contractPage: function() {
                        return true
                    },
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('port');
                        $translatePartialLoader.addPart('keyword');
                        $translatePartialLoader.addPart('company');
                        $translatePartialLoader.addPart('contract');
                        $translatePartialLoader.addPart('contractType');
                        $translatePartialLoader.addPart('contractStatus');
                        $translatePartialLoader.addPart('contractCategory');
                        $translatePartialLoader.addPart('compType');
                        $translatePartialLoader.addPart('commodityType');
                        $translatePartialLoader.addPart('location');
                        $translatePartialLoader.addPart('thirdPartyType');
                        $translatePartialLoader.addPart('priceModel');
                        $translatePartialLoader.addPart('priceType');
                        $translatePartialLoader.addPart('wtUnitType');
                        $translatePartialLoader.addPart('priceType');
                        $translatePartialLoader.addPart('wtUnitType');
                        $translatePartialLoader.addPart('onOff');
                        $translatePartialLoader.addPart('futuresMonth');
                        $translatePartialLoader.addPart('onCallIndex');
                        $translatePartialLoader.addPart('qtyUnitType');
                        $translatePartialLoader.addPart('deliveryType');
                        $translatePartialLoader.addPart('incoTerms');
                        $translatePartialLoader.addPart('paymentType');
                        $translatePartialLoader.addPart('global');
                        $translatePartialLoader.addPart('pricing');
                        $translatePartialLoader.addPart('fixation');
                        $translatePartialLoader.addPart('growth');
                        $translatePartialLoader.addPart('country');
                        $translatePartialLoader.addPart('comment');
                        return $translate.refresh();
                    }],
                    entity: function () {
                        return {
                            createdOn: new Date(),
                            createdBy: null,
                            modifiedOn: new Date(),
                            modifiedBy: null,
                            contractType: "SALE",
                            status: "DRAFT",
                            contractDate: new Date(),
                            contractNum: null,
                            category: null,
                            commodity: "COTTON",
                            buyerRef: null,
                            sellerRef: null,
                            thirdPartyRef: null,
                            thirdPartyType: null,
                            priceModel: 'FIXED',
                            priceDisplay: null,
                            fixedPrice: null,
                            priceType: 'CTS',
                            unitType: 'LB',
                            priceValue: null,
                            quantity: null,
                            qtyUnitType: 'BALES',
                            qtyBales: null,
                            qtyMts: null,
                            qtyLbs: null,
                            qtyKgs: null,
                            qtyDisplay: null,
                            tolerance: null,
                            tolType: null,
                            deliveryType: null,
                            deliveryDisplay: null,
                            cropYear: null,
                            growth: null,
                            growthDisplay: null,
                            origin: null,
                            originDisplay: null,
                            wtBasis: null,
                            wtBasisDisplay: null,
                            strength: null,
                            strengthRange: null,
                            range: null,
                            mic: null,
                            stapleDescription: null,
                            gradeDescription: null,
                            stapleGreenCard: null,
                            gradeGreenCard: null,
                            leafGreenCard: null,
                            unf: null,
                            length: null,
                            gradeDescriptionDisplay: null,
                            gradeGreenCardDisplay: null,
                            stapleDescriptionDisplay: null,
                            stapleGreenCardDisplay: null,
                            micDisplay: null,
                            strengthDisplay: null,
                            strengthRangeDisplay: null,
                            rangeDisplay: null,
                            leafGreenCardDisplay: null,
                            qualityDisplay: null,
                            lengthDisplay: null,
                            unfDisplay: null,
                            incoTerms: null,
                            incoTermsDisplay: null,
                            loadingPortDisplay: null,
                            destinationPortDisplay: null,
                            shipmentPeriods: null,
                            paymentType: null,
                            paymentTypeDisplay: null,
                            paymentTerms: null,
                            paymentTermsDisplay: null,
                            otherTerms: null,
                            otherTermsDisplay: null,
                            requiredDocsDisplay: null,
                            specialClauses: null,
                            id: null,
                            quality: 'DESCRIPTION',
                            outsideBuyerRef: null
                        }
                    }
                }
            })
            .state('sale.edit', {
                parent: 'app',
                url: '/contract/sale/{id}/edit',
                sticky: true,
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_TUI'],
                    pageTitle: 'ccsTrApp.contract.sale.edit',
                    title: 'Edit'
                },
                views: {
                    'contract-sale-edit@': {
                        controller: 'ContractDialogController',
                        controllerAs: 'vm',
                        templateUrl: 'app/entities/contract/contract-dialog.html'
                    }
                },
                resolve: {
                    category: function () {
                        return {
                            type: "SALE"
                        }
                    },
                    contractPage: function() {
                        return true
                    },
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('port');
                        $translatePartialLoader.addPart('keyword');
                        $translatePartialLoader.addPart('company');
                        $translatePartialLoader.addPart('contract');
                        $translatePartialLoader.addPart('contractType');
                        $translatePartialLoader.addPart('contractStatus');
                        $translatePartialLoader.addPart('contractCategory');
                        $translatePartialLoader.addPart('compType');
                        $translatePartialLoader.addPart('commodityType');
                        $translatePartialLoader.addPart('location');
                        $translatePartialLoader.addPart('thirdPartyType');
                        $translatePartialLoader.addPart('priceModel');
                        $translatePartialLoader.addPart('priceType');
                        $translatePartialLoader.addPart('wtUnitType');
                        $translatePartialLoader.addPart('priceType');
                        $translatePartialLoader.addPart('wtUnitType');
                        $translatePartialLoader.addPart('onOff');
                        $translatePartialLoader.addPart('futuresMonth');
                        $translatePartialLoader.addPart('onCallIndex');
                        $translatePartialLoader.addPart('qtyUnitType');
                        $translatePartialLoader.addPart('deliveryType');
                        $translatePartialLoader.addPart('incoTerms');
                        $translatePartialLoader.addPart('paymentType');
                        $translatePartialLoader.addPart('global');
                        $translatePartialLoader.addPart('pricing');
                        $translatePartialLoader.addPart('fixation');
                        $translatePartialLoader.addPart('growth');
                        $translatePartialLoader.addPart('country');
                        $translatePartialLoader.addPart('comment');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'Contract', function ($stateParams, Contract) {
                        return Contract.get({id: $stateParams.id}).$promise;
                    }],
                    entityAudit: ['$stateParams', 'ContractAudit', function ($stateParams, ContractAudit) {
                        return ContractAudit.get({id: $stateParams.id}).$promise;
                    }]
                }
            });

        $stickyStateProvider.enableDebug(true);

    }
})();
